import { useEffect, useCallback, useRef } from 'react';
import { driver, Driver } from 'driver.js';
import { buildTourSteps } from './tourSteps';

interface UseTourOptions {
  subscriptionsEnabled: boolean;
  autoStart: boolean;
}

export function useTour({ subscriptionsEnabled, autoStart }: UseTourOptions) {
  const driverRef = useRef<Driver | null>(null);

  const startTour = useCallback(() => {
    // Destroy any existing instance before starting a new one
    if (driverRef.current) {
      driverRef.current.destroy();
    }

    driverRef.current = driver({
      showProgress: true,
      allowClose: true,
      smoothScroll: false,
      overlayColor: 'rgba(0,0,0,0.65)',
      stagePadding: 6,
      stageRadius: 6,
      popoverClass: 'fenx-tour-popover',
      showButtons: ['next', 'previous', 'close'],
      steps: buildTourSteps(subscriptionsEnabled),
      onDestroyed: () => {
        localStorage.setItem('portal_tour_seen', '1');
      },
    });

    driverRef.current.drive();
  }, [subscriptionsEnabled]);

  useEffect(() => {
    if (!autoStart) return;
    if (window.innerWidth < 1024) return;
    if (localStorage.getItem('portal_tour_seen')) return;

    const timer = setTimeout(() => {
      startTour();
    }, 100);

    return () => clearTimeout(timer);
  }, [autoStart, startTour]);

  return { startTour };
}
